import React, { useState, useEffect } from 'react';

const DENTAL_QUIPS = [
  "Loading… slower than the line for bad coffee at a dental convention.",
  "This page is taking longer than an insurance pre-auth.",
  "Somewhere, a dental rep is saying 'limited time offer' while you wait.",
  "Remember: good things take time. Like endo on #15 (not).",
  "Still faster than a patient finding their insurance card.",
  "Waiting for this to load builds character—just like dental school did.",
  "Getting there … unlike your last lab case that's still 'in progress.'",
  "Think of this as the mental equivalent of waiting for lidocaine to work.",
  "We're condensing data like gutta-percha—warm, slow, and oddly satisfying.",
  "Still faster than waiting on a crown from the cheapest lab in town.",
  "Grinding through the details… just like occlusal adjustments at 4:55 p.m.",
  "Loading… like your dental school debt, it just feels eternal.",
  "Brewing CE gold while the coffee reaches room temperature.",
  "Somewhere a dental consultant is making a pie chart while you wait.",
  "At least there's no motivational speaker with too many PowerPoints."
];

export default function LoadingQuip({ size = "md", className = "", rotate = true }) {
  const [quip, setQuip] = useState("");
  
  useEffect(() => {
    // Pick a random starting quip
    const randomQuip = DENTAL_QUIPS[Math.floor(Math.random() * DENTAL_QUIPS.length)];
    setQuip(randomQuip);
    
    // Rotate quips every 4 seconds if rotate is enabled
    if (rotate) {
      const interval = setInterval(() => {
        const newQuip = DENTAL_QUIPS[Math.floor(Math.random() * DENTAL_QUIPS.length)];
        setQuip(newQuip);
      }, 4000);
      
      return () => clearInterval(interval);
    }
  }, [rotate]);
  
  const sizeClasses = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  };
  
  return (
    <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
      {/* Loading Spinner */}
      <div className="flex space-x-2">
        <div className="w-3 h-3 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
        <div className="w-3 h-3 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
        <div className="w-3 h-3 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
      </div>
      
      {/* Random Dental Quip with fade transition */}
      <p 
        key={quip}
        className={`${sizeClasses[size]} text-slate-600 text-center max-w-md italic px-4 animate-fade-in`}
      >
        {quip}
      </p>
    </div>
  );
}
